import {
  animate,
  AnimationBuilder,
  AnimationPlayer,
  state,
  style,
  transition,
  trigger
} from '@angular/animations';
import { isPlatformBrowser } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  PLATFORM_ID,
  Renderer2,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { ActivatedRoute, UrlSegment } from '@angular/router';
import { UserSessionService } from '@com-delta-idp/mnx-oauth';
import { LoggingService } from '@com-delta-idp/mnx-utils';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject, Subscription } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { AlertAdvisoriesComponent } from '../common/alert-advisories/alert-advisories.component';
import { CookieHelper } from '../common/cookie-helper';
import { CountryLanguageHelper } from '../common/country-language-helper';
import { DataLayer } from '../common/datalayer/datalayer';
import { DeviceTypeHelper } from '../common/device-type-helper';
import { QueryStringHelper } from '../common/query-string-helper';
import { ScrollDirective } from '../common/scroll-directive/scroll.directive';
import { ApplicationConfig } from '../config/config';
import { UrlUtil } from '../config/urlutil';
import { corporatePartners } from '../corporate-partner/corporate-partner.const';
import { ICorporatePartner } from '../corporate-partner/corporate-partner.interface';
import { getCorporatePartner } from '../corporate-partner/corporate-partner.method';
import { SwitchingAccountService } from '../header/switching-account/switching-account.service';
import { ContentAuxiliaryNavigation } from '../model/content/contentauxiliarynavigation.model';
import { ContentCountryLanguage } from '../model/content/contentCountryLanguage.model';
import { ContentDarkSite } from '../model/content/contentDarkSite.model';
import { UnSupportedBrowser } from '../model/content/contentUnsupportedBrowser.model';
import {
  AlternateFlow,
  NextgenReshopHeader,
  TripData
} from '../model/global-nav.interfaces';
import { AccountSummaryService } from '../services/accountsummary/account-summary.service';
import { ClosestAirPortcode } from '../services/closestairportcode.service';
import { CommonService } from '../services/common.service';
import { ContentHeaderFooterService } from '../services/content/contentheaderfooter.service';
import { CountryLanguageService } from '../services/country_Language/country_Language.service';
import { ErrorMessageService } from '../services/error-messages/error-messages.service';
import { LogoutService } from '../services/logout/logout.service';
import { TranslatedsitesLangService } from '../services/translatedsites/translatedsiteslang.service';
import { BookParameters } from './../model/bookparameter.model';
import { LoginComponent } from './login/login.component';
import { MobileWidgetComponent } from './mobile-widget/mobile-widget.component';

export type HeaderWidgetState = 'visible' | 'hidden' | '';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'ngc-global-nav',
  templateUrl: './global-nav.component.html',
  providers: [CookieHelper],
  animations: [
    trigger('navigation', [
      state('true', style({ left: '-100%', display: 'none' })),
      state('false', style({ left: '0%', display: 'block' })),
      transition('0 => 1', animate('.4s')),
      transition('1 => 0', animate('.4s'))
    ]),
    trigger('widgetState', [
      state('visible', style({})),
      state('hidden', style({})),
      transition('* => visible', [
        animate('400ms ease-in', style({ transform: 'translateY(0%)' }))
      ]),
      transition('visible => hidden', [
        animate('400ms ease-out', style({ transform: 'translateY(-100%)' }))
      ])
    ])
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
// tslint:disable: component-class-suffix
export class NgcGlobalNav
  implements OnInit, AfterViewInit, OnChanges, OnDestroy
{
  @ViewChild('ngcGlobalElementRef') ngcGlobalElementRef: ElementRef;
  @ViewChild('toggle') toggle;
  @ViewChild('ngcMobileWidget') ngcMobileWidget: MobileWidgetComponent;
  @ViewChild('widgetContainer') widgetContainer: any;
  @ViewChild('loggedinComponent') loggedinComponent: LoginComponent;
  @ViewChild('scrollDir') scrollDir: ScrollDirective;
  @ViewChild('container') widget: ElementRef;
  @Input('alertAdv') alertAdv: AlertAdvisoriesComponent;
  @Input() alternativeText: string;
  @Input() showTooltip = false;
  @Input() isSlimHeader = false;
  @Input() shopHeaderInput: any;
  @Input() pageName = '';
  @Input() triggerDefaultLookupEvent = 'false';
  @Input() isLightHeader = false;
  @Input() alternateFlow: AlternateFlow = {} as AlternateFlow;
  @Input() findTripData: TripData = {} as TripData;
  @Input() isShoppingAwsFlow = false;
  @Input() nextgenPage = false;
  @Input() hideSearchButton = false;
  @Output() disableBusinessPicker = new EventEmitter();
  @Output() widgetTopPosition = 'sticky';
  @Input() removeSessionStorageKey = '';
  @Output() redirectback = new EventEmitter();
  nextgenReshopHeader: NextgenReshopHeader = {} as NextgenReshopHeader;
  isHamberger: any;
  crpInfo: any;
  isEDPFlag: any;
  widgetState: HeaderWidgetState = 'visible';
  custId: any;
  prefCity = '';
  prefCityCode: string;
  selectedNavItem;
  navigation = true;
  isMobileAndTabletDevice = false;
  flightStatusMobile = false;
  fromAirport: any;
  toAirport: any;
  isInitComplete = false;
  auxiliaryArr: ContentAuxiliaryNavigation[];
  isAlertAdvisory = false;
  isBannerExist = false;
  isloggedIn = false;
  showWidgetFromExternalEvent = false;
  islegacyApp = false;
  isCheckInEligible = false;
  widgetOutsideClicked: boolean;
  widgetOffset = 0;
  navbarTop = 0;
  selectedTrip = '';
  widgetContainerTop = 0;
  showMobileWidget = false;
  contentContactUs: any;
  contentMyFlightPanel: any;
  unSupportedBrowser: UnSupportedBrowser;
  prefCookieValue: any;
  cookieDetails: any;
  cookieUserCountry = 'ind';
  showCookieTerms = false;
  windowHeight = 0;
  businessUser = false;
  displayBusinessTypeSection = false;
  disableBusinessHomePage: any;
  displayHeaderWidget = true;
  contentDataAvailable = false;
  isBusinessLoginDisabled = true;
  restrictProfileSelector = false;
  tempEdpFlag = false;
  companySelected: any;
  hasCorpCookie: any;
  contentServiceHeaderFooterSubscribe: Subscription;
  closestAirportCodeSubsriber: Subscription;
  bsModalRef: BsModalRef;
  config = {
    animated: false
  };

  countryLanguageContent: ContentCountryLanguage;
  contentHeaderFooterServiceSubscribe: Subscription;
  modalServiceOnHiddenSubscribe: Subscription;
  logOutServiceSubscribe: Subscription;
  isDarkSiteEnabled = true;
  isLightHeaderFooterEnable = false;
  darkSiteThemeContent: ContentDarkSite;
  isWidgetEnable = false;
  isInspireMenu = false;
  interstitialBusiness = false;
  isPrimaryNavExpandCollapse = false;
  isEnabled = 'true';
  isNotHome = false;
  siteSearch = false;
  clickedClassName: string;
  isMobileDevice = false;
  headerHeight = 0;
  queryParam: BookParameters;
  shopExperience: string;
  isadvanceSearch: boolean;
  contentInterstitialBanner: any;
  showHeaderWidget = true;
  showHeaderWidgetOnClick = false;
  timeout = null;
  widgetElementsOrLinksClicked = false;
  widgetTop = 0;
  widgetPostionfrmTop = 0;
  showHeaderWidgetAtTop = false;
  addOrRemoveButtonClicked = false;
  backgroundDivHeight = 0;
  player: AnimationPlayer;
  deviceTypes: any = [];
  storeModalRef: BsModalRef;
  bsModalConfirmationRef: BsModalRef;
  modalOnHiddenSubscription: Subscription;
  mkcpgn = '';
  isWarmState = false;
  isReady = false;
  deepLinkCacheKey;
  accountSummaryServiceSubscribe: Subscription;
  slimFlag = false;
  shopHeader = false;
  isHipmunk = false;
  enableSearch = true;
  partnerId = 'default';
  corpPartner: ICorporatePartner = corporatePartners[0];
  disableCLS = true;
  businessAccountOptionsList: any =
    this.switchingAccountService.initializeViewData();

  APP_DISABLE_LEGACY = false;
  canBookNonRefundable: string;
  private unsubscribe: Subject<void> = new Subject();
  showNewProfileSelector: boolean;
  darkSiteLevel = '';
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private modalService: BsModalService,
    private cdf: ChangeDetectorRef,
    private srv: CommonService,
    private cookieHelper: CookieHelper,
    private contentService: ContentHeaderFooterService,
    private rend: Renderer2,
    private el: ElementRef,
    private datalayer: DataLayer,
    private closestAirportCode: ClosestAirPortcode,
    private countryLangSvc: CountryLanguageService,
    private urlUtil: UrlUtil,
    private appconfig: ApplicationConfig,
    private _builder: AnimationBuilder,
    private countryLanguageHelper: CountryLanguageHelper,
    private _deviceTypeHelper: DeviceTypeHelper,
    private _route: ActivatedRoute,
    private aemErrorMessages: ErrorMessageService,
    public switchingAccountService: SwitchingAccountService,
    private accountSummaryDetails: AccountSummaryService,
    private logOutService: LogoutService,
    private queryStringHelper: QueryStringHelper,
    private transSitesLangService: TranslatedsitesLangService,
    private userSession: UserSessionService,
    private loggingService: LoggingService
  ) {}

  @HostListener('window:resize', ['$event']) onResize(event) {
    if (isPlatformBrowser(this.platformId) && document && window) {
      const width = Math.max(
        document.documentElement.clientWidth,
        window.innerWidth || 0
      );
      const height = Math.max(
        document.documentElement.clientHeight,
        window.innerHeight || 0
      );
      this.windowHeight = height;
      if (width < 1025 && width > 767) {
        const mobileWidget = document.getElementsByClassName(
          'mobile-widget-modal'
        );
        if (
          mobileWidget !== undefined &&
          mobileWidget !== null &&
          mobileWidget.length > 0
        ) {
          const closeModalContainer =
            document.getElementsByTagName('modal-container');
          const closeBackdrop =
            document.getElementsByTagName('bs-modal-backdrop');
          if (
            closeModalContainer &&
            closeModalContainer !== undefined &&
            closeBackdrop &&
            closeBackdrop !== undefined
          ) {
            this.rend.setStyle(closeModalContainer[0], 'display', 'none');
            this.rend.setStyle(closeBackdrop[0], 'display', 'none');
          }
        }
      }
      if (width < 992) {
        this.isMobileAndTabletDevice = true;
        this.showMobileWidget = true;
        if (this.APP_DISABLE_LEGACY === false) {
          this.isNotHome = true;
          const activeItem =
            this.el.nativeElement.querySelector('.active-menu');
          if (activeItem) {
            this.rend.removeClass(activeItem, 'active-menu');
          }
        }
      } else {
        this.isMobileAndTabletDevice = false;
        this.showMobileWidget = false;
        if (this.APP_DISABLE_LEGACY === false) {
          if (this.isNotHome === true) {
            const activeItem =
              this.el.nativeElement.querySelector('.active-menu');
            if (activeItem) {
              this.rend.removeClass(activeItem, 'active-menu');
            }
          }
        }
      }
      if (!this.navigation) {
        this.navigationDrawer();
      }
      this.setNavBarTop();
      this.cdf.detectChanges();
      this.setWidgetContainerTop();
      if (this.APP_DISABLE_LEGACY === false) {
        this.isMobileAndTabletDevice = false;
      }
      if (this.isHeaderWidget()) {
        this.setShowHeaderWidgetAtTop();
      }
      this.cdf.detectChanges();
    }
  }

  @HostListener('window:load', ['$event']) onLoad(event) {
    if (isPlatformBrowser(this.platformId) && document && window) {
      if (this.alertAdv) {
        this.isAlertAdvisory = this.alertAdv.showAlertAdvisoriesHeader;
      }
      const width = Math.max(
        document.documentElement.clientWidth,
        window.innerWidth || 0
      );
      const height = Math.max(
        document.documentElement.clientHeight,
        window.innerHeight || 0
      );
      this.windowHeight = height;
      if (width < 992) {
        this.isMobileAndTabletDevice = true;
        this.showMobileWidget = true;
      } else {
        this.isMobileAndTabletDevice = false;
        this.showMobileWidget = false;
      }
      if (this.APP_DISABLE_LEGACY === false) {
        this.isBannerExist =
          document.getElementById('bannerMessaging') !== null ? true : false;
        if (this.isBannerExist) {
          this.rend.addClass(
            document.getElementById('bannerMessaging'),
            'fixed-top'
          );
        }
      }
      this.setNavBarTop();
      this.setWidgetContainerTop();
      this.removeAlertAdvLoadClass();
      if (
        this.APP_DISABLE_LEGACY === false &&
        this.appconfig.get('APP_SHOP_HEADER') === 'false'
      ) {
        this.isMobileAndTabletDevice = false;
        this.rend.addClass(document.querySelector('html'), 'hp-legacy');
      }
      if (this.isHeaderWidget()) {
        this.setShowHeaderWidgetAtTop();
      }
      this.cdf.detectChanges();
    }
  }

  // TODO: SSR is breaking with use of KeyboardEvent
  @HostListener('document:keyup', ['$event']) handleKeyboardEvent(event: any) {
    if (isPlatformBrowser(this.platformId)) {
      const x = event.keyCode;
      const rect = document.activeElement.getBoundingClientRect();
      if (x === 9) {
        if (
          document.activeElement.getBoundingClientRect().top <
          this.widgetContainerTop
        ) {
          document.documentElement.scrollTop -= this.widgetContainerTop + 2;
        }
      }
      this.handleEscapeEvent(event);
    }
  }

  @HostListener('document:click', ['$event']) onclick(event) {
    if (
      event &&
      event.target.classList &&
      event.target.classList.contains('bussiness-alert-close')
    ) {
      if (document.querySelectorAll('.bussiness-alert-banner')) {
        document.querySelectorAll('.bussiness-alert-banner')[1][
          'style'
        ].display = 'none';
      }
    }
    if (isPlatformBrowser(this.platformId)) {
      if (this.APP_DISABLE_LEGACY === false) {
        if (
          event &&
          event.target.classList &&
          (event.target.classList.contains('closeBannerMessage') ||
            event.target.classList.contains('bannerMessageMoreInfo'))
        ) {
          this.isBannerExist =
            document.getElementById('bannerMessaging') !== null ? true : false;
          this.setNavBarTop();
          this.setWidgetContainerTop();
          this.cdf.detectChanges();
        }
      }
    }
    if (this.isHeaderWidget()) {
      this.setWidgetElementsOrLinksClicked(
        event.target.className,
        event.target.parentElement
      );
      this.setAddOrRemoveButtonClicked(event.target.className);
    }
  }

  @HostListener('window:scroll', ['$event']) onWindowScroll(event) {
    if (this.isHeaderWidget()) {
      const scroll = this.scrollHappened();
      if (!scroll) {
        if (
          (window.pageYOffset === 0 && this.showHeaderWidgetAtTop) ||
          (this.scrollDir &&
            this.scrollDir.direction == 'up' &&
            this.widgetTopPosition != 'sticky' &&
            document.getElementsByClassName('carousel-inner').length > 0 &&
            document
              .getElementsByClassName('carousel-inner')[0]
              .getBoundingClientRect().bottom > 0)
        ) {
          this.widgetTop = 0;
          this.widgetTopPosition = 'sticky';
          if (
            document.getElementsByClassName('adv-search-container').length > 0
          ) {
            document.getElementsByClassName('adv-search-container')[0][
              'style'
            ].position = 'sticky';
          }
        }
      } else if (this.showHeaderWidget) {
        if (
          this.scrollDir &&
          this.scrollDir.direction == 'down' &&
          this.widgetTopPosition == 'fixed'
        ) {
          this.widgetTop = this.scrollDir.lastScrollTop;
          this.widgetTopPosition = '';
        } else if (
          this.scrollDir &&
          this.scrollDir.direction == 'down' &&
          this.widgetTopPosition != 'sticky' &&
          document.getElementsByClassName('widget-container-lg').length > 0 &&
          document
            .getElementsByClassName('widget-container-lg')[0]
            .getBoundingClientRect().bottom <= 0
        ) {
          this.widgetTop = 0;
          this.widgetTopPosition = 'sticky';
        } else if (
          this.scrollDir &&
          this.scrollDir.direction == 'up' &&
          this.widgetTopPosition != 'sticky'
        ) {
          this.widgetTopPosition = 'fixed';
          this.widgetTop = 0;
        }
      }
    }
  }

  getAccountSummary() {
    if (!this.isLightHeader) {
      return this.accountSummaryDetails.getAccountSummaryDetails().subscribe(
        (res) => {
          this.isReady = true;
          if (res !== null) {
            this.checkForBusiness(res);
            this.isWarmState = res.isWarmState;
            this.canBookNonRefundable = res.canBookNonRefundable;
          }
        },
        (err) => {
          this.isReady = true;
        }
      );
    }
  }

  listenToEvents() {
    // TODO: needs to refactor code - B-664953
    if (isPlatformBrowser(this.platformId)) {
      document.addEventListener('service-worker-token', () => {
        this.makeGetDashBrdDataHelper();
      });

      document.addEventListener('minimize-button-click', () => {
        this.widgetTopPosition = 'sticky';
      });
    }
  }

  makeGetDashBrdDataHelper() {
    if (this.userSession.getServiceWorkerCheck()) {
      this.accountSummaryServiceSubscribe = this.getAccountSummary();
    }
    this.checkLightHeaderFooter();
    this.addMacPaddingRtZero();
    this.navigation = true;
    this.queryParam = new BookParameters();
    this.queryParam.isQueryParam = false;
    try {
      this._route.queryParams
        .pipe(filter((params) => params.mkcpgn))
        .subscribe((params) => {
          this.mkcpgn = params.mkcpgn;
          this.cdf.detectChanges();
        });
      this._route.queryParams
        .pipe(filter((params) => params.widgetNav))
        .subscribe((params) => {
          this.setQueryParams(params);
          this.cdf.detectChanges();
        });
      const shopexp = this.appconfig.get('APP_SHOP_EXPERIENCE');
      if (
        shopexp !== undefined &&
        shopexp !== null &&
        this._route.snapshot.queryParams[shopexp] !== undefined &&
        this._route.snapshot.queryParams[shopexp] !== null
      ) {
        this.shopExperience = this._route.snapshot.queryParams[shopexp];
      }
      this.contentService._isHeaderFooter
        .pipe(takeUntil(this.unsubscribe))
        .subscribe((headerFooterFlag) => {
          if (!this.transSitesLangService.getAlertFlag()) {
            headerFooterFlag = true;
          }
          if (headerFooterFlag) {
            if (this.contentService.contentHeaderFooter) {
              this.contentServiceHeaderFooterSubscribe =
                this.contentService.contentHeaderFooter
                  .pipe(takeUntil(this.unsubscribe))
                  .subscribe((data) => {
                    this.showNewProfileSelector =
                      !!data?.header?.enableNewProfileSelector;
                    this.contentDataAvailable = data && data.header;
                    this.displayHeaderWidget =
                      data && data.header && data.header.enableWidgetExpandar;
                    if (this.alternateFlow.enabled) {
                      this.nextgenReshopHeader =
                        data && data.nextgenReshopHeader;
                    }
                    if (
                      isPlatformBrowser(this.platformId) &&
                      document &&
                      document.body
                    ) {
                      if (this.displayHeaderWidget) {
                        document.body.classList.add('scrollWidgetEnabled');
                      } else {
                        document.body.classList.remove('scrollWidgetEnabled');
                      }
                    }
                    if (
                      data.header.auxiliaryNavigation.get('interstitialBanner')
                    ) {
                      this.contentInterstitialBanner =
                        data.header.auxiliaryNavigation.get(
                          'interstitialBanner'
                        ).details;
                    }
                    if (
                      this.srv.checkEmptyNullUndefined(
                        data.header.disableBusinessHomePage
                      )
                    ) {
                      this.isBusinessLoginDisabled =
                        data.header.disableBusinessHomePage.toLowerCase() ===
                        'true'
                          ? true
                          : false;
                    } else {
                      this.isBusinessLoginDisabled = true;
                    }
                    const respObj = {
                      flag: this.tempEdpFlag,
                      isWarmState: this.isWarmState
                    };
                    this.getEdpFlag(respObj);
                    this.disableBusinessPicker.emit(
                      this.isBusinessLoginDisabled
                    );
                    if (!this.isBusinessLoginDisabled) {
                      this.prefCookieValue =
                        this.cookieHelper.getCookies('prefUI');
                      // checks if corp cookie exists or not
                      this.hasCorpCookie = this.cookieHelper.getCookies('corp');
                      if (this.hasCorpCookie) {
                        const corpCookie = this.cookieHelper.getCookies('corp');
                        const passCorpName = corpCookie
                          .split('|')[1]
                          .split('=')[1]
                          .replace(/#/g, ' ');
                        this.businessUser = true;
                        this.switchingAccountService.toggleAccount(
                          this.hasCorpCookie,
                          false
                        );
                        this.switchingAccountService.setCorporateName(
                          passCorpName
                        );
                        this.switchingAccountService.setIntranetlink(true);
                        this.displayBusinessTypeSection = true;
                      }
                    }
                    this.setCorpPartner();
                    const contentData = data;
                    this.countryLanguageContent = data.footer.countryLanguage;
                    if (contentData && contentData.unsupportedBrowserPopup) {
                      this.unSupportedBrowser =
                        contentData.unsupportedBrowserPopup;
                    }

                    if (contentData && contentData.darkSite) {
                      this.darkSiteThemeContent = contentData.darkSite;
                      if (
                        this.darkSiteThemeContent.isEnabled === this.isEnabled
                      ) {
                        this.showCookieTerms = false;
                        if (
                          this.darkSiteThemeContent.level ===
                          this.appconfig.get('APP_DARKSITE_LEVEL_0')
                        ) {
                          this.isDarkSiteEnabled = false;
                          this.isWidgetEnable = true;
                          const body = document.getElementsByTagName('body')[0];
                          body.classList.add('dark-site');
                        } else if (
                          this.darkSiteThemeContent.level ===
                            this.appconfig.get('APP_DARKSITE_LEVEL_1') ||
                          this.darkSiteThemeContent.level ===
                            this.appconfig.get('APP_DARKSITE_LEVEL_2')
                        ) {
                          this.isDarkSiteEnabled = true;
                          this.isWidgetEnable = true;
                          this.isPrimaryNavExpandCollapse = true;
                          const activeItem =
                            this.el.nativeElement.querySelector('.active-menu');
                          if (activeItem) {
                            this.rend.removeClass(activeItem, 'active-menu');
                          }
                        } else {
                          this.isDarkSiteEnabled = true;
                          this.isWidgetEnable = false;
                        }
                        this.darkSiteLevel =
                          this.darkSiteThemeContent.enableBlackTheme === 'true'
                            ? this.darkSiteThemeContent.level
                            : '';
                      }
                    }
                    if (this.APP_DISABLE_LEGACY === false) {
                      this.isNotHome = true;
                      this.isMobileAndTabletDevice = false;
                    }
                    if (contentData && contentData.header) {
                      if (contentData.header.primaryNavigations) {
                        const mainNav = Array.from(
                          contentData.header.primaryNavigations.values()
                        );
                        if (data.header.auxiliaryNavigation.get('contactUs')) {
                          this.contentContactUs =
                            data.header.auxiliaryNavigation.get(
                              'contactUs'
                            ).details;
                        }
                        if (
                          data.header.auxiliaryNavigation.get('myFlightPanel')
                        ) {
                          this.contentMyFlightPanel =
                            data.header.auxiliaryNavigation.get(
                              'myFlightPanel'
                            ).details;
                        }
                        if (mainNav && mainNav[0]) {
                          if (this.isPrimaryNavExpandCollapse) {
                            this.selectedNavItem = '';
                          } else {
                            this.selectedNavItem = mainNav[0]['id'];
                          }
                        }
                        // added to initialize banner content variable to pass for switching account template
                      }

                      if (contentData.header.auxiliaryNavigation) {
                        this.auxiliaryArr = Array.from(
                          contentData.header.auxiliaryNavigation.values()
                        );
                        this.removeSignupfromAuxillaryArray();
                      }
                      this.cdf.detectChanges();
                    }

                    if (this.alertAdv) {
                      this.isAlertAdvisory =
                        this.alertAdv.showAlertAdvisoriesHeader;
                      this.alertAdv.alertAdvisoryClosed
                        .pipe(takeUntil(this.unsubscribe))
                        .subscribe(
                          (_data) => {
                            this.isAlertAdvisory = false;
                            this.setNavBarTop();
                            this.setWidgetContainerTop();
                          },
                          (err) => {
                            this.loggingService.log('Caught Error: ' + err);
                          }
                        );
                    }
                  });
            }
          }
        });
      if (this.isHeaderWidget()) {
        this.setShowHeaderWidgetAtTop();
      }
      if (isPlatformBrowser(this.platformId) && window && !window['rhpr']) {
        this.aemErrorMessages.loadErrorMessages();
      }

      this.handleSiteSearchWidget();
    } catch (e) {}

    this.switchingAccountService.corporatePartnerChange.subscribe(
      (corpPartner: ICorporatePartner) => {
        this.corpPartner = corpPartner;
        const account =
          this.switchingAccountService.getAccountCookie('account');
        if (account && account.length) {
          const parseAccount = JSON.parse(account);
          this.businessAccountOptionsList =
            parseAccount['businessAccountOptionsList'];
          if (this.showNewProfileSelector) {
            this.businessUser = parseAccount['isBusiness'];
          }
        }
        this.corpPartner = this.srv.getCorpPartner(
          this.partnerId,
          this.corpPartner,
          this.deepLinkCacheKey
        );
        this.cdf.detectChanges();
      }
    );
    window['globalNavRef'] = {
      openWidget: (value: string) => this.openWidgetFromOutsideLink(value)
    };
    this.nonHomepage();
    if (this.APP_DISABLE_LEGACY === false) {
      if (isPlatformBrowser(this.platformId) && document) {
        const el = document.getElementsByClassName('skip-content-container')[0];
        if (el !== null && el !== undefined) {
          if (
            el.getElementsByTagName('a')[0] !== null &&
            el.getElementsByTagName('a')[0] !== undefined
          ) {
            el.getElementsByTagName('a')[0].classList.add('skip-main-content');
          }
        }
        const inspireMenu = document.body.querySelector(
          '.inspiration-sub-nav-container'
        );
        if (inspireMenu !== null && inspireMenu !== undefined) {
          this.isInspireMenu = true;
        } else {
          this.isInspireMenu = false;
        }
        this.islegacyApp = true;
      }
    }
    if (isPlatformBrowser(this.platformId)) {
      this._deviceTypeHelper
        .deviceDetection()
        .pipe(takeUntil(this.unsubscribe))
        .subscribe((resp) => {
          this.deviceTypes = resp;
          if (this.deviceTypes.isMobile) {
            this.isMobileDevice = true;
          }
        });
    }
  }

  ngOnInit() {
    this.prefCookieValue = this.cookieHelper.getCookies('prefUI');
    this.APP_DISABLE_LEGACY = JSON.parse(
      this.appconfig.get('APP_DISABLE_LEGACY')
    );
    if (
      isPlatformBrowser(this.platformId) &&
      document &&
      document.body &&
      window
    ) {
      try {
        this.deepLinkCacheKey = this.getQueryParams('cacheKeySuffix');
        this.setCorpPartner();
        if (document.body.clientWidth < 992) {
          this.widgetContainerTop = 47;
        } else {
          this.widgetContainerTop = 75;
        }
        const windowPath = window.location.pathname;
        if (windowPath) {
          const contextPath = windowPath.split('/')[1];
          const slimHeaderPathString = this.appconfig.get(
            'APP_SLIM_HEADER_PATHS'
          );
          if (slimHeaderPathString && slimHeaderPathString.trim() !== '') {
            const slimHeaderPaths = slimHeaderPathString.split(',');
            if (
              slimHeaderPaths &&
              slimHeaderPaths.length > 0 &&
              slimHeaderPaths.indexOf(contextPath) > -1
            ) {
              this.isSlimHeader = true;
            }
          }
        }
        const width = Math.max(
          document.documentElement.clientWidth,
          window.innerWidth || 0
        );
        const height = Math.max(
          document.documentElement.clientHeight,
          window.innerHeight || 0
        );
        this.windowHeight = height;
        if (width < 992) {
          this.isMobileAndTabletDevice = true;
          this.showMobileWidget = true;
        } else {
          this.isMobileAndTabletDevice = false;
          this.showMobileWidget = false;
        }
      } catch (err) {}

      this.srv.removeDeepLinkVendorCookie();
    }
    this.restrictProfileSelector = this.srv.hidingProfileSelector();
    if (this.appconfig.get('APP_SITESEARCH_TURN_OFF') === 'true') {
      this.enableSearch = false;
    } else {
      this.enableSearch = true;
    }
    if (
      this.isHipmunkCookieSet(this.restrictProfileSelector) &&
      this.appconfig.get('APP_SHOP_HEADER') !== undefined &&
      this.appconfig.get('APP_SHOP_HEADER') === 'true'
    ) {
      // Display or hide the static header
      if (this.shopHeaderInput) {
        this.shopHeader = true;
      } else {
        this.shopHeader = false;
      }
    }
    if (isPlatformBrowser(this.platformId)) {
      this.makeGetDashBrdDataHelper();
    }
    this.srv.removeSessionStorageKey = this.removeSessionStorageKey;
  }

  ngOnChanges(change: SimpleChanges) {
    if (isPlatformBrowser(this.platformId)) {
      if (change.triggerDefaultLookupEvent) {
        this.cdf.detectChanges();
      }
      this.listenToEvents();
    }
  }

  ngAfterViewInit() {
    this.isInitComplete = true;
    if (isPlatformBrowser(this.platformId)) {
      if (!this.showCookieTerms) {
        window.focus();
      }
      try {
        if (this.ngcGlobalElementRef !== undefined) {
          this.datalayer.dataReady(this.ngcGlobalElementRef);
        }
      } catch (error) {
        this.loggingService.log(
          'Caught Error in datalayer.dataReady: ' + error
        );
      }
    }
  }

  nonHomepage() {
    if (
      isPlatformBrowser(this.platformId) &&
      (!this.transSitesLangService.propertyCheck() ||
        !this.transSitesLangService.getAlertFlag())
    ) {
      this.transSitesLangService.detectCurrentLanguage(this.el, this.rend);
    }
  }

  handleEscapeEvent(event) {
    const isModalOpen = document
      .getElementsByTagName('body')[0]
      .classList.contains('modal-open');
    if (
      event.keyCode === 27 &&
      isModalOpen &&
      this.storeModalRef !== undefined &&
      this.storeModalRef !== null
    ) {
      const modalContainer = document.getElementsByTagName('modal-container');
      if (
        modalContainer !== undefined &&
        modalContainer !== null &&
        modalContainer.length > 0
      ) {
        if (modalContainer[0].classList.contains('search-footer-modal')) {
          this.storeModalRef.content.footerSearchModalLoaded = false;
        } else if (
          modalContainer[0].classList.contains('notification-header-modal')
        ) {
          this.storeModalRef.content.notificationModalLoaded = false;
        } else if (
          modalContainer[0].classList.contains('notification-loggedin-modal')
        ) {
          const el = this.el.nativeElement.querySelector('.toggle-up');
          if (el !== null && el !== undefined && el.querySelector('img')) {
            el.className = 'toggle-flyout';
            el.querySelector('img').setAttribute('alt', 'Collapsed');
          }
          this.storeModalRef.content.loggedInModalLoaded = false;
        }
        this.storeModalRef.hide();
      }
      document.getElementsByTagName('body')[0].classList.remove('modal-open');
    }
  }

  /** Handle the widget behaviour on site search page */
  handleSiteSearchWidget() {
    this._route.url.subscribe((url: UrlSegment[]) => {
      if (
        (url.length > 0 && url[0].path && url[0].path === 'site-search') ||
        window.location.pathname.includes('site-search') ||
        (url.length > 0 && url[0].path && url[0].path === 'sitesearch') ||
        window.location.pathname.includes('sitesearch')
      ) {
        /**
         * The Homepage app has the APP_DISABLE_LEGACY prop enable.
         * For having this work, we need to turn it off;
         * if not, then the widget will not close.
         */
        if (this.APP_DISABLE_LEGACY) {
          this.APP_DISABLE_LEGACY = false;
        }
        this.siteSearch = true;
        this.isWidgetEnable = true;
      }
    });
  }

  checkLightHeaderFooter() {
    if (
      this.appconfig?.get('APP_HEADERFOOTER_LIGHT_WEIGHT') === 'true' ||
      this.isLightHeader
    ) {
      this.isLightHeaderFooterEnable = true;
      this.isNotHome = true;
    }
  }

  isHipmunkCookieSet(pageRestricted: boolean): boolean {
    const hipmunkCookie =
      this.cookieHelper.getCookieValue('isHipmunk') !== null
        ? this.cookieHelper.getCookieValue('isHipmunk')
        : false;
    const hipmunkPaxCount = this.urlUtil.getURLParam('paxCount', null);
    if (this.pageName !== '' && this.pageName === 'confirmation') {
      // this.pageNameFromProperties) {
      this.cookieHelper.setCookieName('isHipmunk', '', 0, false);
      this.partnerId = this.setPartnerIdName('personal'); // need to work
    } else if (hipmunkCookie) {
      this.setBusinessFlagForHipmunk();
      this.partnerId = pageRestricted
        ? 'hipmunk'
        : this.setPartnerIdName('default');
    } else {
      if (
        this.urlUtil.getURLParam('hipmunk-id', null) !== null &&
        hipmunkPaxCount !== null
      ) {
        // set hipmunk cookie only if pax count is 1
        if (hipmunkPaxCount === '1' || hipmunkPaxCount === 1) {
          this.cookieHelper.setCookieName('isHipmunk', true, 0, true);
          this.setBusinessFlagForHipmunk();
          this.partnerId = 'hipmunk';
        } else {
          this.cookieHelper.setCookieName('isHipmunk', '', 0, false);
          this.partnerId = this.setPartnerIdName('default'); // need to work
        }
      }
    }
    if (this.partnerId === 'default' || this.partnerId === 'personal') {
      this.setCorpPartner();
    } else {
      this.corpPartner = getCorporatePartner(this.partnerId);
    }
    return true;
  }

  setBusinessFlagForHipmunk() {
    this.isHipmunk = true;
    this.switchingAccountService.toggleAccount(false, true);
  }

  setPartnerIdName(partnerIdName: string): string {
    const setPartnerToPersonal =
      this.cookieHelper.getCookieValue('restrictToPersonal');
    if (setPartnerToPersonal && setPartnerToPersonal.length) {
      return setPartnerToPersonal;
    } else {
      return partnerIdName;
    }
    // return partnerIdName;
  }

  addMacPaddingRtZero() {
    if (isPlatformBrowser(this.platformId)) {
      const bodyRoot = document.getElementsByTagName('body')[0];
      if (navigator.userAgent.indexOf('Mac') > 0) {
        if (!(bodyRoot.className.indexOf('mac-pr-0') >= 0)) {
          this.rend.addClass(bodyRoot, 'mac-pr-0');
        }
      }
    }
  }

  setNavBarTop() {
    if (isPlatformBrowser(this.platformId) && document) {
      const alertAdvContainer = document.getElementsByClassName(
        'alert-advisory-main-container'
      )[0];
      const bannerContainer = document.getElementById('bannerMessaging');
      if (this.isAlertAdvisory === true && this.isBannerExist === false) {
        if (alertAdvContainer !== undefined) {
          this.navbarTop = alertAdvContainer.clientHeight;
          this.rend.removeStyle(alertAdvContainer, 'visibility');
        }
      } else if (
        this.isAlertAdvisory === false &&
        this.isBannerExist === true
      ) {
        if (bannerContainer !== undefined) {
          this.navbarTop = bannerContainer.clientHeight - 1;
        }
      } else if (this.isAlertAdvisory === true && this.isBannerExist === true) {
        if (alertAdvContainer !== undefined && bannerContainer !== undefined) {
          this.navbarTop =
            alertAdvContainer.clientHeight + bannerContainer.clientHeight - 1;
          this.rend.setStyle(
            alertAdvContainer,
            'top',
            bannerContainer.clientHeight + 'px'
          );
          this.rend.removeStyle(alertAdvContainer, 'visibility');
        }
      } else {
        this.navbarTop = 0;
      }
      this.cdf.detectChanges();
    }
  }

  inspireSubNavPosition() {
    if (isPlatformBrowser(this.platformId) && document && document.body) {
      const alertAdvisoryEl = document.body.querySelector(
        '.alert-advisory-main-container'
      );
      let alertAdvisoryHeight;
      if (alertAdvisoryEl !== null && alertAdvisoryEl !== undefined) {
        alertAdvisoryHeight = alertAdvisoryEl.clientHeight;
      } else {
        alertAdvisoryHeight = 0;
      }
      const navBarEl = document.body.querySelector('.navbar-expand-lg');
      let navBarHeight;
      if (navBarEl !== null && navBarEl !== undefined) {
        navBarHeight = navBarEl.clientHeight;
      } else {
        navBarHeight = 0;
      }
      let widgetHeight = this.calcHeaderHeight();
      this.headerHeight = alertAdvisoryHeight + navBarHeight + widgetHeight;
      const el = document.getElementsByClassName(
        'inspiration-sub-nav-container'
      )[0];
      if (el !== null && el !== undefined) {
        this.rend.setStyle(el, 'margin-top', this.headerHeight + 'px');
      }
    }
  }

  calcHeaderHeight() {
    const widgetE1 = document.body.querySelector('.widget-container-lg');
    const widgetE2 = document.body.querySelector('.adv-search-container');
    let widgetHeight, widgetE1height, widgetE2height;
    if (widgetE1 !== null && widgetE1 !== undefined) {
      widgetE1height = widgetE1.clientHeight;
    } else {
      widgetE1height = 0;
    }
    if (widgetE2 !== null && widgetE2 !== undefined) {
      widgetE2height = widgetE2.clientHeight;
    } else {
      widgetE2height = 0;
    }
    widgetHeight = widgetE1height + widgetE2height;

    return widgetHeight;
  }

  setWidgetContainerTop() {
    if (isPlatformBrowser(this.platformId) && document) {
      const navBarContainer = document.getElementsByClassName('navbar')[0];
      const alertAdvContainer = document.getElementsByClassName(
        'alert-advisory-main-container'
      )[0];
      const bannerContainer = document.getElementById('bannerMessaging');
      if (this.isAlertAdvisory === true && this.isBannerExist === false) {
        if (alertAdvContainer !== undefined) {
          this.widgetContainerTop =
            alertAdvContainer.clientHeight + navBarContainer.clientHeight;
          if (this.isMobileAndTabletDevice) {
            this.widgetContainerTop = this.widgetContainerTop + 1;
          }
        } else {
          this.widgetContainerTop = navBarContainer.clientHeight;
          if (this.isMobileAndTabletDevice) {
            this.widgetContainerTop = this.widgetContainerTop + 1;
          }
        }
      } else if (
        this.isAlertAdvisory === false &&
        this.isBannerExist === true
      ) {
        if (bannerContainer !== undefined) {
          this.widgetContainerTop =
            bannerContainer.clientHeight + navBarContainer.clientHeight;
          if (this.isMobileAndTabletDevice) {
            this.widgetContainerTop = this.widgetContainerTop + 1;
          }
        } else {
          this.widgetContainerTop = navBarContainer.clientHeight;
          if (this.isMobileAndTabletDevice) {
            this.widgetContainerTop = this.widgetContainerTop + 1;
          }
        }
      } else if (this.isAlertAdvisory === true && this.isBannerExist === true) {
        if (alertAdvContainer !== undefined && bannerContainer !== undefined) {
          this.widgetContainerTop =
            alertAdvContainer.clientHeight +
            bannerContainer.clientHeight +
            navBarContainer.clientHeight;
          if (this.isMobileAndTabletDevice) {
            this.widgetContainerTop = this.widgetContainerTop + 1;
          }
        } else {
          this.widgetContainerTop = navBarContainer.clientHeight;
          if (this.isMobileAndTabletDevice) {
            this.widgetContainerTop = this.widgetContainerTop + 1;
          }
        }
      } else {
        this.widgetContainerTop = navBarContainer.clientHeight;
        if (this.isMobileAndTabletDevice) {
          this.widgetContainerTop = this.widgetContainerTop + 1;
        }
      }
    }
  }

  removeAlertAdvLoadClass() {
    if (isPlatformBrowser(this.platformId) && document) {
      if (this.isAlertAdvisory) {
        const alertAdvContainer = document.getElementsByClassName(
          'alert-advisory-main-container'
        )[0];
        if (alertAdvContainer) {
          alertAdvContainer.classList.remove('advisory-on-load');
        }
      }
    }
  }

  clickedOutsideWidget(clickedOutside) {
    if (clickedOutside) {
      this.showWidgetFromExternalEvent = false;
      if (this.APP_DISABLE_LEGACY === false) {
        if (!this.isNotHome) {
          this.isNotHome = true;
          const activeItem =
            this.el.nativeElement.querySelector('.active-menu');
          if (activeItem) {
            this.rend.removeClass(activeItem, 'active-menu');
          }
        }
      }
    }
    this.widgetOutsideClicked = clickedOutside;
    if (this.isInspireMenu === true && this.APP_DISABLE_LEGACY === false) {
      this.cdf.detectChanges();
      this.inspireSubNavPosition();
    }
  }

  openWidgetFromOutsideLink(widget: string) {
    this.showWidgetFromExternalEvent = true;
    this.toggleContent(widget, event);
    this.cdf.detectChanges();
  }

  updateWidgetOffset() {
    const advSearch = this.el.nativeElement.querySelector(
      '.adv-search-container'
    );
    this.widgetOffset = advSearch ? advSearch.offsetHeight : 0;
  }

  removeSignupfromAuxillaryArray() {
    if (this.auxiliaryArr) {
      const loginIndex = this.auxiliaryArr.findIndex(
        (item) => item.id === 'login'
      );
      const signupIndex = this.auxiliaryArr.findIndex(
        (item) => item.id === 'signup'
      );
      if (loginIndex > -1 && signupIndex > -1) {
        this.auxiliaryArr.splice(signupIndex, 1);
      }
    }
  }

  recievOpenAdvanceSearch($event) {
    this.isadvanceSearch = $event;
  }

  isHeaderWidget(): boolean {
    return (
      !this.isMobileAndTabletDevice &&
      !this.isSlimHeader &&
      this.displayHeaderWidget
    );
  }

  toggleContent(selectedItem, event) {
    if (this.contentDataAvailable && this.isHeaderWidget()) {
      this.widgetOffset = 0;
      if (window.pageYOffset === 0) {
        this.widgetTop = 0;
        this.widgetTopPosition = 'sticky';
      } else if (this.scrollDir && !isNaN(this.scrollDir.lastScrollTop)) {
        this.widgetTopPosition = 'fixed';
        this.widgetTop = 0;
        this.widgetPostionfrmTop = this.scrollDir.lastScrollTop;
      }
      if (document.getElementsByClassName('adv-search-container').length > 0) {
        document.getElementsByClassName('adv-search-container')[0][
          'style'
        ].position = 'sticky';
      }
      if (window.pageYOffset >= 1) {
        this.showHeaderWidgetOnClick = true;
      }
    }
    if (selectedItem === 'book') {
      this.triggerDefaultLookupEvent =
        this.triggerDefaultLookupEvent === 'true' ? 'true' : 'false';
    }
    if (this.scrollDir && this.scrollDir.scrollCrossedWidget) {
      this.showWidgetFromExternalEvent = true;
    }
    this.removeDisplayNone();
    if (selectedItem === '-1' && this.APP_DISABLE_LEGACY === false) {
      this.selectedNavItem = 'book';
      this.cdf.detectChanges();
    }
    if (this.isInitComplete) {
      if (!this.isMobileAndTabletDevice) {
        let currentNavItem;
        if (event && event.srcElement && event.srcElement.parentElement) {
          currentNavItem = event.srcElement.parentElement;
        }
        if (this.isPrimaryNavExpandCollapse === true) {
          if (this.isWidgetEnable === true) {
            this.selectedNavItem = selectedItem;
            this.isWidgetEnable = false;
            if (currentNavItem) {
              this.rend.addClass(currentNavItem, 'active-menu');
            }
          } else {
            if (this.selectedNavItem !== selectedItem) {
              this.selectedNavItem = selectedItem;
              this.isWidgetEnable = false;
              if (currentNavItem) {
                this.rend.addClass(currentNavItem, 'active-menu');
              }
            } else {
              this.selectedNavItem = selectedItem;
              this.isWidgetEnable = true;
              if (currentNavItem) {
                this.rend.removeClass(currentNavItem, 'active-menu');
              }
            }
          }
        } else {
          this.selectedNavItem = selectedItem;
          this.isWidgetEnable = false;
          this.isNotHome = selectedItem !== undefined ? false : this.isNotHome;
          if (this.APP_DISABLE_LEGACY === false) {
            if (currentNavItem) {
              this.rend.addClass(currentNavItem, 'active-menu');
            }
          }
        }
        if (this.isInspireMenu === true && this.APP_DISABLE_LEGACY === false) {
          this.cdf.detectChanges();
          this.inspireSubNavPosition();
        }
      } else {
        this.selectedNavItem = selectedItem;
        this.cdf.detectChanges();
        if (this.selectedNavItem && this.selectedNavItem !== '-1') {
          this.ngcMobileWidget.selectedNavItem = this.selectedNavItem;
          this.ngcMobileWidget.openMobileWidgetModal();
        }
      }
    }

    if (!this.navigation) {
      this.navigation = true;
    }
  }

  removeDisplayNone(): void {
    if (isPlatformBrowser(this.platformId)) {
      if (this.APP_DISABLE_LEGACY === false) {
        requestAnimationFrame(() => {
          const widgetDnone = document.getElementsByClassName(
            'widget-container-lg'
          )[0] as HTMLElement;
          if (widgetDnone) {
            widgetDnone.style.display = 'block';
            widgetDnone.classList.remove('d-none');
            if (
              this.appconfig.get('APP') === 'static' &&
              this.appconfig.get('APP_BAU_OR_STATIC_PG') === 'true'
            ) {
              widgetDnone.classList.remove('d-sm-none');
              widgetDnone.classList.remove('d-md-none');
              widgetDnone.classList.remove('d-lg-none');
            }

            this.cdf.detectChanges();
          }
        });
      }
    }
  }

  expandButtonClicked() {
    this.selectedNavItem = 'book';
    this.cdf.detectChanges();
    this.ngcMobileWidget.openMobileWidgetModal();
  }

  navigationDrawer() {
    const infoEL = document.getElementsByClassName(
      'information-sub-nav-container'
    );
    if (this.APP_DISABLE_LEGACY === false) {
      this.isMobileAndTabletDevice = true;
    }
    // if (this.toggle && this.toggle.nativeElement && this.toggle.nativeElement.offsetParent !== null) {
    this.navigation = !this.navigation;
    // }
    if (!this.navigation) {
      document.getElementsByTagName('body')[0].classList.add('hamburger-open');
      if (infoEL && infoEL.length > 0) {
        infoEL[0].classList.remove('fixed-top');
      }
    } else {
      document
        .getElementsByTagName('body')[0]
        .classList.remove('hamburger-open');
      if (infoEL && infoEL.length > 0) {
        infoEL[0].classList.add('fixed-top');
      }
    }
  }

  getLoggedIn(flag: any) {
    this.isloggedIn = flag;
  }

  getPrefCity(flag) {
    if (flag !== undefined) {
      this.prefCityCode = flag;
    }
  }

  getCustId(flag) {
    if (flag !== undefined) {
      this.custId = flag;
    }
  }

  getCrpNames(crpData) {
    this.crpInfo = crpData;
  }

  setEdpFlag(res) {
    this.tempEdpFlag = res.flag;
    this.isWarmState = res.isWarmState;
  }

  checkForBusiness(res) {
    const agreementRes = res.crprtName;
    if (agreementRes) {
      const accountCookiePresent = this.cookieHelper.getCookies('account');
      if (accountCookiePresent === null || accountCookiePresent === undefined) {
        const personalAccount = {
          isBusiness: false,
          name: encodeURIComponent(res.firstName.toString()),
          businessAccountOptionsList: {
            isOaSmeAccount: false,
            partnerId: 'personal',
            accoutnIndex: 0,
            restrictPaxToOne: false,
            displayInLineText: ''
          }
        };
        const stringifyObject = JSON.stringify(personalAccount);
        this.cookieHelper.setCookieName('account', stringifyObject, 0, true);
      }
    }
  }

  getEdpFlag(res) {
    this.hasCorpCookie = this.cookieHelper.getCookies('corp');
    const hipmunkCookie =
      this.cookieHelper.getCookieValue('isHipmunk') !== null
        ? this.cookieHelper.getCookieValue('isHipmunk')
        : false;
    if (!this.isBusinessLoginDisabled) {
      const setBusinessFlag =
        (this.hasCorpCookie && !res.flag) ||
        (hipmunkCookie && this.pageName !== 'confirmation')
          ? true
          : res.flag;
      this.isEDPFlag = setBusinessFlag;
      // code added for checking cookie existing or not and load
      let cookieObj = this.switchingAccountService.getAccountCookie('account');
      if (cookieObj && cookieObj.length) {
        cookieObj = JSON.parse(cookieObj);
        this.businessUser = cookieObj['isBusiness'];
        this.businessAccountOptionsList =
          cookieObj['businessAccountOptionsList'];
        this.partnerId =
          hipmunkCookie && this.pageName !== 'confirmation'
            ? 'hipmunk'
            : this.businessAccountOptionsList['partnerId'];
        this.corpPartner = getCorporatePartner(this.partnerId);
        this.displayBusinessTypeSection = true; // cookieObj['isBusiness'];
        this.switchingAccountService.setBusinessUser(cookieObj['isBusiness']);
        this.switchingAccountService.toggleAccount(
          cookieObj['isBusiness'],
          false
        );
        if (this.hasCorpCookie && !res.flag) {
          this.switchingAccountService.displayBusinessAccounts(res.flag);
        }
      } else {
        // DDCFB - Hardcoding for now - need to move the entire logic once Login provides the correct data.
        const restrictedPageCookieObj =
          this.switchingAccountService.getAccountCookie('accountType');
        const showAsPersonal =
          (restrictedPageCookieObj !== '' &&
            restrictedPageCookieObj.split('-')[1] === 'true') ||
          (res.flag && res.isWarmState)
            ? false
            : setBusinessFlag;
        this.partnerId =
          restrictedPageCookieObj !== '' &&
          restrictedPageCookieObj.split('-')[1] === 'true'
            ? 'personal'
            : this.getPartnerId(
                hipmunkCookie,
                this.pageName,
                this.hasCorpCookie,
                res.flag
              );
        this.corpPartner = getCorporatePartner(this.partnerId);
        this.businessUser = showAsPersonal;
        this.displayBusinessTypeSection = setBusinessFlag;
        this.switchingAccountService.setBusinessUser(showAsPersonal);
        this.switchingAccountService.toggleAccount(showAsPersonal, false);
        if (this.hasCorpCookie && !res.flag) {
          const passCorpName = this.cookieHelper
            .getCookies('corp')
            .split('|')[1]
            .split('=')[1]
            .replace(/#/g, ' ');
          this.switchingAccountService.setCorporateName(passCorpName);
          this.switchingAccountService.displayBusinessAccounts(res.flag);
        }
      }
      // }
    }
    this.isEDPFlag = res.flag;
  }

  getPartnerId(hipmunkCookie, pageName, corpCookie, flag) {
    const setPartnerToPersonal =
      this.cookieHelper.getCookieValue('restrictToPersonal');
    if (hipmunkCookie && pageName !== 'confirmation') {
      return 'hipmunk';
    } else if (corpCookie) {
      return 'edp';
    } else if (setPartnerToPersonal && setPartnerToPersonal.length) {
      return setPartnerToPersonal;
    } else {
      return 'default';
    }
  }

  getCheckInEligible(flag) {
    if (flag !== undefined) {
      this.isCheckInEligible = flag;
    }
  }

  closeInfo() {
    this.showCookieTerms = false;
  }

  setQueryParams(params) {
    this.queryParam.isQueryParam = true;
    this.queryParam.originCity = params.originCity;
    this.queryParam.destinationCity = params.destinationCity;
    this.queryParam.tripType = params.tripType;
    this.queryParam.refundableFlightsOnly = params.refundableFlightsOnly;
    this.queryParam.awardTravel = params.awardTravel;
    this.queryParam.flexAirport = params.flexAirport;
    this.queryParam.cabinFareClass = params.cabinFareClass;
    this.queryParam.departureDate = params.departureDate;
    this.queryParam.awardTravel = params.awardTravel;
    this.queryParam.returnDate = params.returnDate;
    this.queryParam.cabinFareClass = params.cabinFareClass;
    this.queryParam.action = params.action;
    this.queryParam.deltaOnly = params.deltaOnly;
    this.queryParam.deltaOnlySearch = params.deltaOnlySearch;
    this.queryParam.go = params.go;
    this.queryParam.adtCount = params.adtCount;
    this.queryParam.gbeCount = params.gbeCount;
    this.queryParam.childCount = params.childCount;
    this.queryParam.infantCount = params.infantCount;
    this.queryParam.meetingEventCode = params.meetingEventCode;
  }

  myTripDataLoaded() {
    this.cdf.detectChanges();
  }

  saveModalServiceRef(openedModalRef) {
    this.storeModalRef = openedModalRef;
  }

  logOut() {
    if (isPlatformBrowser(this.platformId) && document) {
      let logoutUrl = '';
      if (
        this.appconfig.get('APP_LOGOUT_URL_FROM_PROPERTY') === 'true' &&
        this.appconfig.get('APP_NEW_LOGOUT_URL') !== undefined
      ) {
        logoutUrl = this.appconfig.get('APP_NEW_LOGOUT_URL');
      } else {
        logoutUrl = this.contentMyFlightPanel.logoutUrl;
      }
      this.logOutServiceSubscribe = this.logOutService
        .logOutAction(logoutUrl)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(
          (res) => {
            this.logOutService.pingLogOut();
            // window.location.replace(this.urlUtil.hostUrl);
          },
          (err) => {
            window.location.replace('/');
            this.loggingService.log('Caught Error: ' + err);
          }
        );
    }
  }

  scrollHappened(): boolean {
    let scroll = true;
    if (
      (window.pageYOffset === 0 && this.showHeaderWidgetAtTop) ||
      this.showHeaderWidgetOnClick ||
      this.widgetElementsOrLinksClicked ||
      this.scrollCrossedWidgetHappened() ||
      this.addOrRemoveButtonClicked
    ) {
      scroll = false;
      this.resetShowHeaderOnClickFlag();
      this.resetWidgetElementsOrLinksClickedFlag();
      this.resetAddOrRemoveButtonClickedFlag();
    }
    return scroll;
  }

  scrollCrossedWidgetHappened() {
    return this.scrollDir && !this.scrollDir.scrollCrossedWidget;
  }

  resetShowHeaderOnClickFlag(): void {
    if (this.showHeaderWidgetOnClick) {
      this.showHeaderWidgetOnClick = false;
    }
  }

  resetWidgetElementsOrLinksClickedFlag(): void {
    if (this.widgetElementsOrLinksClicked) {
      this.widgetElementsOrLinksClicked = false;
    }
  }

  setWidgetElementsOrLinksClicked(
    className: string,
    element: HTMLElement
  ): void {
    if (element || className) {
      this.clickedClassName = className;
      if (
        !this.widgetOutsideClicked ||
        (typeof className === 'string' &&
          (className.includes('arrow-wht-expander icon-advsearchtriangle') ||
            className.includes('select-ui-optionList') ||
            className.includes('airport-code') ||
            className.includes('departCity') ||
            className.includes('arrivalCity') ||
            className.includes('connection-desc') ||
            className.includes('calDispValueCont') ||
            className.includes('calenderDepartSpan'))) ||
        (element &&
          (element.classList.contains('departCity') ||
            element.classList.contains('arrivalCity') ||
            element.classList.contains('airportLookup-list') ||
            element.classList.contains('multicity-connection-airport')))
      ) {
        this.widgetElementsOrLinksClicked = true;
      } else {
        this.widgetElementsOrLinksClicked = false;
      }
    }
  }

  setAddOrRemoveButtonClicked(className: string): void {
    if (className && typeof className === 'string') {
      if (
        className.includes('add-flight') ||
        className.includes('remove-flight')
      ) {
        this.addOrRemoveButtonClicked = true;
      } else {
        this.addOrRemoveButtonClicked = false;
      }
    }
  }

  resetAddOrRemoveButtonClickedFlag(): void {
    if (this.addOrRemoveButtonClicked) {
      this.addOrRemoveButtonClicked = false;
    }
  }

  closeWidgetElements(): void {
    if (!this.widget) {
      return;
    }
    const calendar: HTMLDivElement = this.widget.nativeElement.querySelector(
      '.calDispValueCont.icon-Calendar'
    );
    if (calendar && calendar.classList.contains('open')) {
      calendar.dispatchEvent(new Event('click'));
    }
    const dropdowns: HTMLUListElement[] = Array.from(
      this.widget.nativeElement.querySelectorAll(
        '.select-ui-optionUL:not(.hideOption)'
      )
    );
    if (dropdowns) {
      dropdowns.forEach((dropdown: HTMLUListElement) => {
        if (dropdown && dropdown.offsetParent) {
          dropdown.offsetParent
            .querySelector('.select-ui-wrapper')
            .dispatchEvent(new Event('click'));
        }
      });
    }
  }

  setShowHeaderWidgetAtTop(): void {
    if (
      this.appconfig.get('APP_HEADER_WIDGET_EXPAND_AT_TOP') &&
      this.appconfig.get('APP_HEADER_WIDGET_EXPAND_AT_TOP') === 'true'
    ) {
      this.showHeaderWidgetAtTop = true;
    }
  }

  setAdvSearchAnimation(): HeaderWidgetState {
    let value: HeaderWidgetState = '';
    if (this.isHeaderWidget()) {
      if (this.showHeaderWidget) {
        value = 'visible';
      } else {
        value = 'hidden';
      }
    }
    return value;
  }

  setHeaderWidget(errorPresent: boolean): void {
    if (window.pageYOffset >= 1 && errorPresent) {
      this.showHeaderWidgetOnClick = true;
    }
  }

  setSelectedTrip(tripType: string): void {
    this.selectedTrip = tripType;
  }

  getHeroImageHeight(widgetNativeElement): number {
    return (
      this.getWidgetMarginTopValue(widgetNativeElement) +
      widgetNativeElement.clientHeight +
      this.widgetOffset
    );
  }

  setHeroImageHeight(): number {
    if (!this.widget) {
      return;
    }
    let heroImageHeight;
    if (
      this.isWidgetEnable ||
      this.isNotHome ||
      this.isLightHeaderFooterEnable ||
      !this.showHeaderWidget
    ) {
      const widgetNativeElement = this.widget.nativeElement;
      if (window.pageYOffset === 0) {
        heroImageHeight = this.getHeroImageHeight(widgetNativeElement);
      }
    } else {
      heroImageHeight = 0;
    }
    if (
      this.appconfig.get('APP') &&
      this.appconfig.get('APP') === 'static' &&
      this.appconfig.get('APP_BAU_OR_STATIC_PG') &&
      this.appconfig.get('APP_BAU_OR_STATIC_PG') === 'true'
    ) {
      heroImageHeight = 0;
    }
    return heroImageHeight;
  }

  setWidgetMaxHeight(): number {
    if (!this.widget) {
      return;
    }
    const enhancedHeader = this.isHeaderWidget();
    const widgetNativeElement = this.widget.nativeElement;
    let widgetMaxHeight = 0;
    if (enhancedHeader && window.pageYOffset && window.pageYOffset === 0) {
      widgetMaxHeight = widgetNativeElement.scrollHeight + this.widgetOffset;
      if (
        this.isEnhancedHomePageHeaderWidget() &&
        widgetNativeElement.scrollHeight
      ) {
        this.backgroundDivHeight =
          this.getWidgetMarginTopValue(widgetNativeElement) +
          widgetNativeElement.clientHeight +
          this.widgetOffset;
      }
    } else if (
      this.scrollDir &&
      this.scrollDir.scrollCrossedWidget &&
      this.showWidgetFromExternalEvent &&
      !this.isMobileAndTabletDevice
    ) {
      widgetMaxHeight = this.windowHeight - this.widgetContainerTop;
    } else {
      widgetMaxHeight = widgetNativeElement.scrollHeight + this.widgetOffset;
    }
    return widgetMaxHeight;
  }

  clearTimeouts(): void {
    if (!this.timeout) {
      return;
    }
    clearTimeout(this.timeout);
  }

  isEnhancedHomePageHeaderWidget(): boolean {
    return this.isHeaderWidget() && this.showHeaderWidgetAtTop;
  }

  setWidgetOverFlow(): string {
    let overflow = '';
    if (
      this.isHeaderWidget() &&
      document.getElementsByTagName('ngc-multicity').length > 0
    ) {
      overflow = 'auto';
    }
    return overflow;
  }

  getWidgetMarginTopValue(element: any): number {
    if (!element) {
      return;
    }
    let marginTop = 0;
    const elementStyle = element.style;
    if (
      elementStyle &&
      elementStyle.marginTop &&
      elementStyle.marginTop.length
    ) {
      marginTop = parseInt(elementStyle.marginTop);
    }
    return marginTop;
  }

  getQueryParams(queryParamName: string) {
    let queryParamValue;
    if (
      this._route.snapshot.queryParams &&
      this._route.snapshot.queryParams[queryParamName] !== undefined &&
      this._route.snapshot.queryParams[queryParamName] !== null
    ) {
      queryParamValue = this._route.snapshot.queryParams[queryParamName];
    } else {
      queryParamValue = undefined;
    }
    if (!queryParamValue) {
      queryParamValue =
        this.queryStringHelper.getParameterByName(queryParamName);
    }
    return queryParamValue;
  }

  setCorpPartner() {
    try {
      const isDeepLinkProcess =
        this.srv.getDeepLinkVendor() === '' ? false : true;
      let deepLinkXssid;
      let deepLinkCacheKey;
      let deepLinkVendor;
      if (isDeepLinkProcess) {
        deepLinkXssid = this.getQueryParams('deepLinkXssid');
        deepLinkCacheKey = this.getQueryParams('cacheKeySuffix');
        deepLinkVendor = this.getQueryParams('vendorID');
      }
      const deepLinkCacheKeyCookieValue =
        this.cookieHelper.getCookieValue('deepLinkCacheKey');
      const deepLinkVendorCookieValue = this.cookieHelper.getCookieValue(
        'deepLinkVendor' + this.deepLinkCacheKey
      );
      if (
        isDeepLinkProcess &&
        deepLinkVendor &&
        deepLinkVendor === this.srv.getDeepLinkVendor()
      ) {
        this.srv.setDeepLinkVendorCookie(deepLinkVendor, deepLinkCacheKey);
        this.corpPartner = getCorporatePartner(deepLinkVendor);
      } else if (
        isDeepLinkProcess &&
        this.deepLinkCacheKey &&
        this.deepLinkCacheKey === deepLinkCacheKeyCookieValue &&
        deepLinkVendorCookieValue &&
        deepLinkVendorCookieValue === this.srv.getDeepLinkVendor()
      ) {
        this.corpPartner = getCorporatePartner(deepLinkVendorCookieValue);
      } else {
        this.corpPartner = getCorporatePartner(this.partnerId);
      }
    } catch (error) {
      this.corpPartner = getCorporatePartner(this.partnerId);
    }
  }

  ngOnDestroy() {
    if (this.contentServiceHeaderFooterSubscribe) {
      this.contentServiceHeaderFooterSubscribe.unsubscribe();
    }
    if (this.logOutServiceSubscribe) {
      this.logOutServiceSubscribe.unsubscribe();
    }
    if (this.closestAirportCodeSubsriber) {
      // Load ObsUnsub
      this.closestAirportCodeSubsriber.unsubscribe();
    }
    if (this.modalOnHiddenSubscription) {
      // Load ObsUnsub
      this.modalOnHiddenSubscription.unsubscribe();
    }
    if (this.accountSummaryServiceSubscribe) {
      this.accountSummaryServiceSubscribe.unsubscribe();
    }
    this.unsubscribe.next();
    this.unsubscribe.complete();
    this.unsubscribe.unsubscribe();
    this.cdf.detach();
  }

  redirectBackToCallingApp() {
    this.redirectback.emit(true);
  }
}
